<template>
  <section
    class="table"
    :class="`table--cols-${cols.length}`">
    <div class="table__head row">
      <div
        v-for="(col, key) in cols"
        :key="`col${key}`"
        :class="`col--${(100 / cols.length).toFixed()}`"
        class="col">
        <p v-html="col.name"></p>
      </div>
    </div>
    <div class="table__body">
      <div
        v-for="(row, key) in rows"
        :key="`row${key}`"
        class="row"
        :class="{ 'row--break': isBreak(row) }">
        <a
          v-if="row.link !== ''"
          target="_blank"
          rel="noopener noreferrer"
          :href="row.link">
          <div
            v-for="(col, index) in getCols(row)"
            :key="`rowCol${index}`"
            :class="`col--${(100 / cols.length).toFixed()}`"
            class="col">
            <p v-html="col"></p>
          </div>
        </a>
        <div
          v-else
          class="row__container">
          <div
            v-for="(col, index) in getCols(row)"
            :key="`rowCol${index}`"
            :class="`col--${(100 / cols.length).toFixed()}`"
            class="col">
            <p v-html="col"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TableBlock',
  props: {
    cols: {
      type: Array,
      default: null
    },
    rows: {
      type: Array,
      default: null
    }
  },
  methods: {
    getCols(row) {
      let index = 0
      let rowCols = []

      for (const col in row) {
        if (index < this.cols.length) {
          rowCols.push(row[col])
          index++
        }
      }

      return rowCols
    },
    isBreak(row) {
      let index = 0
      let isBreak = true

      for (const col in row) {
        if (index < this.cols.length) {
          if (row[col] !== '') {
            isBreak = false
          }
          index++
        }
      }

      return isBreak
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  display:flex;
  flex-wrap:wrap;
  margin: #{$padding * 4} 0;
  &__head {
    width:100%;
    &.row {
      display:flex;
      padding: 0 0 $page-padding * 1.5 0 !important;
      border-bottom:2px solid;
      background-color: transparent !important;
      p {
        color: $dk-grey;
      }
    }
  }

  &__body {
    width:100%;
  }

  .row {
    display:flex;
    width:100%;
    padding: 0.75rem 0 0.5rem 0;
    border-bottom:2px solid;

    div {
      display: flex;
      // width: 100%;
    }

    &__container {
      width: 100%;
    }

    a {
      display:flex;
      width:100%;
      position:relative;
      display:inline-flex;
      transition: opacity 120ms ease-in-out;
      &:hover {
        opacity:0.65;
        &:after {
          content:' ';
          position:absolute;
          height:2px;
          width:calc(100% + 20px);
          background-color:#000;
          left: -10px;
          bottom:-12px;
        }
      }
    }

    &--break {
      margin:$padding 0;
    }

    &:nth-child(odd) {
      // background-color:rgba(240,240,240,0.65);
    }
  }

  .col {
    padding: 0 #{$padding * 1} 0 0;

    &:last-child {
      // padding-right:0px;
    }

    &--25 {
      width: 25%;
    }

    &--20 {
      width: 20%;
    }

    &--50 {
      width:50%;
    }

    &--33 {
      width:33.3%;
    }
  }

  @include mobile {
    min-width:540px;
    margin: #{$padding * 2} 0 #{$padding * 2} 0;
  }
}
</style>
